import { ThemeExtension } from '@liscio/ui';

/**
 * Firm document preview (Files page + Messages attachment preview) palette adjustments.
 *
 * `documentPreviewMutedText` is the header's secondary-text blue-gray from the Files page
 * mock: the rename/details buttons, the chips' field names and empty values. It is darker
 * than `text.secondary` and has no equivalent in the shared neutrals ramp, so it lives
 * here as an app-specific token rather than in the cross-product palette. The same value
 * drives `@liscio/ui` FieldChip's muted label through `fieldChipMutedText`.
 */
const DOCUMENT_PREVIEW_MUTED_TEXT = '#6A7086';

export const documentPreview: ThemeExtension = () => ({
  palette: {
    common: {
      documentPreviewMutedText: DOCUMENT_PREVIEW_MUTED_TEXT,
      fieldChipMutedText: DOCUMENT_PREVIEW_MUTED_TEXT,
    },
  },
});
